// Language metadata and role-scoped availability.
// Each language: code (ISO 639-1), nativeName shown in the switcher, englishName.
export const LANGUAGES = {
  en: { code: 'en', nativeName: 'English', englishName: 'English' },
  da: { code: 'da', nativeName: 'Dansk', englishName: 'Danish' },
  de: { code: 'de', nativeName: 'Deutsch', englishName: 'German' },
  hu: { code: 'hu', nativeName: 'Magyar', englishName: 'Hungarian' },
  pl: { code: 'pl', nativeName: 'Polski', englishName: 'Polish' },
  ro: { code: 'ro', nativeName: 'Română', englishName: 'Romanian' },
  bg: { code: 'bg', nativeName: 'Български', englishName: 'Bulgarian' },
  cs: { code: 'cs', nativeName: 'Čeština', englishName: 'Czech' },
  sk: { code: 'sk', nativeName: 'Slovenčina', englishName: 'Slovak' },
  sr: { code: 'sr', nativeName: 'Српски', englishName: 'Serbian' },
  hr: { code: 'hr', nativeName: 'Hrvatski', englishName: 'Croatian' },
};

// Which languages each role may choose from (spec-defined).
export const ROLE_LANGUAGES = {
  employee: ['en', 'hu', 'pl', 'ro', 'bg', 'cs', 'sk', 'sr', 'hr'],
  customer: ['en', 'da', 'de'],
  admin: ['en', 'da'],
  support: ['en', 'da'],
};

// Every language that exists in the app (union of all roles).
export const ALL_LANGUAGES = ['en', 'da', 'de', 'hu', 'pl', 'ro', 'bg', 'cs', 'sk', 'sr', 'hr'];

export const DEFAULT_LANGUAGE = 'en';

/**
 * Languages a given role is allowed to pick. Unknown/absent role → all languages
 * (used on public/auth screens before we know the role).
 */
export const languagesForRole = (role) => {
  if (role && ROLE_LANGUAGES[role]) return ROLE_LANGUAGES[role];
  return ALL_LANGUAGES;
};
